import React, {
  useEffect,
  useState,
  useContext,
} from "react";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../AuthContext";
import { useMsal } from "@azure/msal-react";
import { protectedResources } from "../../msalConfig";
import axios from "axios";
import { DATABOOK_API } from "../../constants/serverConfig";
import { TELEMETRY_API } from "../../constants/serverConfig";
import { MarkerType } from "reactflow";
import "reactflow/dist/style.css";
import ReactFlowChart from "./ReactFlowChart";

import { VscSettingsGear } from "react-icons/vsc";
import { BsFillDatabaseFill } from "react-icons/bs";
import { GetToken } from "../../GetTokentComponent";
import {
  setCertifiedDatasetsFunction,
  setMetricsDataFunction,
  setPastOneMonthUserVisitFunction,
} from "./InfoDetailsService";

import { DownloadOutlined } from "@ant-design/icons";
import { Button, Radio } from "antd";
import FileSaver from "file-saver";
import { Buffer } from "buffer";
import { toast } from "react-toastify";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { AiOutlineFullscreen, AiOutlineFullscreenExit } from "react-icons/ai";
import { MdRestore } from "react-icons/md";

const DataLineage = ({ lineageData, fetchLineageData }) => {
  const [initNodes, setInitNodes] = useState([]);
  const [initEdges, setInitEdges] = useState([]);
  const [infoOnClick, setInfoOnClick] = useState(false);
  const [clickedNodeInfo, setClickedNodeInfo] = useState([]);
  const [certifiedetails, setCertifiedDatasets] = useState({});
  const [modaldata, setModalData] = useState([]);
  const [metricsdata, setmetricsData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [oneMonthUserVisitCount, setPastOneMonthUserVisit] = useState("");
  const [show, setShow] = useState(true);
  const [lineagedirection, setLineageDirection] = useState("");
  const [downloadDisableFlag, setDownloadDisableFlag] = useState(true);
  const [csvloading, setCsvLoading] = useState(false);
  const [jsonloading, setJsonLoading] = useState(false);

  const params = useParams();

  const fullScreenHandle = useFullScreenHandle();
  // console.log("fullScreenHandle", fullScreenHandle.active);

  const { getToken, token, error } = useContext(AuthContext);
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const request = {
    scopes: protectedResources.databook.scopes,
    account: account,
  };
  let apiParameter = {
    instance,
    account,
    request,
  };

  const onClick = async (event, node) => {
    setShow(true);
    setInfoOnClick(true);
    setClickedNodeInfo(node);

    const COLUMN_API = `${DATABOOK_API}/datasets/${node}`;
    const METRICS_API = `${TELEMETRY_API}metrics/latest?object_id=${node}`;

    try {
      const token = await GetToken(apiParameter);
      if (token) {
        await getInfoDetails(token, COLUMN_API, node);
        getdetailsmetricsdata(token, METRICS_API);
        getUserVisitInPastOneMonth(token);
      }
    } catch (error) {
      console.error("API request error:", error);
    }
  };

  const getInfoDetails = setCertifiedDatasetsFunction(
    setModalData,
    setCertifiedDatasets
  );

  const getdetailsmetricsdata = setMetricsDataFunction(
    setIsFetching,
    clickedNodeInfo,
    setmetricsData
  );

  const getUserVisitInPastOneMonth = setPastOneMonthUserVisitFunction(
    clickedNodeInfo,
    setPastOneMonthUserVisit
  );

  // useEffect(() => {
  //   const fetchData = async () => {
  //     (async () => await getToken())();
  //     if (token) {
  //       await getLineageData(token);
  //     }
  //     if (error) {
  //       try {
  //         const rtoken = (await instance.acquireTokenRedirect(request))
  //           .accessToken;
  //         await getLineageData(rtoken);
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     }
  //   };

  //   fetchData();
  // }, [getToken, token, params.id]);

  // let Lineage_API;

  // Lineage_API = `${DATABOOK_API}/lineage/datasets/${params.id}/Any/2`;

  // const getLineageData = async (token) => {

  //   axios
  //     .get(Lineage_API, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: "Bearer " + token,
  //       },
  //     })
  //     .then((res) => {
  //       console.log("Lineage_API Triggered");
  //       let data = res.data;
  //       transformDataToElements(data);
  //       console.log(data, "React Flow Data");
  //     });
  // };

  useEffect(() => {
    transformDataToElements(lineageData);
  }, [lineageData]);

  const transformDataToElements = (lineageData) => {
    let sourceId;
    if (lineageData.inbound && lineageData.inbound.length > 0) {
      sourceId = lineageData.inbound[0]?.edge?.edgeTo.split("/").pop();
    } else {
      sourceId = lineageData.outbound[0]?.edge?.edgeFrom.split("/").pop();
    }

    let dataLabel = lineageData.currentNode.node?.fqn;

    const sourceNode = [
      {
        id: sourceId,
        data: { label: dataLabel?.split("/").splice(-1) },
        fqn: lineageData.currentNode.node?.fqn,
      },
    ];

    setInitNodes((sourceArray) => [...sourceArray, ...sourceNode]);

    if (lineageData.inbound && lineageData.inbound.length > 0) {
      const input = lineageData.inbound.map((inboundNode) => {
        let edgeId = inboundNode?.edge?.edgeFrom.split("/").pop();
        let dataLabel = inboundNode.node.fqn;

        let formattedDataLabel;
        // Disabling for pipedream dataset
        // if (inboundNode.node.name) {
        //   formattedDataLabel = inboundNode.node.name;
        // } else {

        switch (true) {
          case dataLabel.includes("sqlserver"):
            formattedDataLabel = dataLabel.split("~~~")[0];
            break;
          case dataLabel.includes("/"):
            formattedDataLabel = dataLabel.split("/").splice(-1);
            break;
          case dataLabel.includes("."):
            formattedDataLabel = dataLabel.split(".").splice(-1);
            break;
          default:
            formattedDataLabel = dataLabel.split("_").splice(-1);
            break;
        }
        // }


        return {
          id: edgeId,

          type: "customUpdater",
          data: {
            label: formattedDataLabel,
            nodeType: inboundNode.edge?.edgeType,
            dataIcon: <BsFillDatabaseFill color="#42b0d5" />,
            taskIcon: <VscSettingsGear color="#fa6a55" />,
            onClick: (event) => onClick(event, inboundNode.node.fqn),
          },
          fqn: inboundNode.node.fqn,
        };
      });
      setInitNodes((prevArray) => [...prevArray, ...input]);
    }

    if (lineageData.outbound && lineageData.outbound.length > 0) {
      const output = lineageData.outbound.map((outboundNode) => {
        let edgeId = outboundNode?.edge?.edgeTo.split("/").pop();
        let dataLabel = outboundNode.node.fqn;

        let formattedDataLabel;
        // Disabling for pipedream dataset
        // if (outboundNode.node.name) {
        //   formattedDataLabel = outboundNode.node.name;
        // } else {

        switch (true) {
          case dataLabel.includes("sqlserver"):
            formattedDataLabel = dataLabel.split("~~~")[0];
            break;
          case dataLabel.includes("/"):
            formattedDataLabel = dataLabel.split("/").splice(-1);
            break;
          case dataLabel.includes("."):
            formattedDataLabel = dataLabel.split(".").splice(-1);
            break;
          default:
            formattedDataLabel = dataLabel.split("_").splice(-1);
            break;
        }
        // }


        return {
          // id: nodeId,
          id: edgeId,

          type: "customUpdater",
          data: {
            label: formattedDataLabel,
            nodeType: outboundNode?.edge?.edgeType,
            dataIcon: <BsFillDatabaseFill color="#42b0d5" />,
            taskIcon: <VscSettingsGear color="#fa6a55" />,
            onClick: (event) => onClick(event, outboundNode?.node.fqn),
          },
          fqn: outboundNode.node.fqn,
        };
      });

      setInitNodes((prevA) => [...prevA, ...output]);
    }

    const inputEdge = lineageData.inbound.map((inboundNode) => {
      return {
        id: inboundNode.edge.edgeId,
        source: inboundNode.edge.edgeFrom.split("/").pop(),
        target: inboundNode.edge.edgeTo.split("/").pop(),
        markerEnd: {
          type: MarkerType.ArrowClosed,
        },
      };
    });
    const outputEdge = lineageData.outbound.map((outboundNode) => {
      return {
        id: outboundNode.edge.edgeId,
        source: outboundNode.edge.edgeFrom.split("/").pop(),
        target: outboundNode.edge.edgeTo.split("/").pop(),
        markerEnd: {
          type: MarkerType.ArrowClosed,
        },
      };
    });

    setInitEdges(inputEdge.concat(outputEdge));
  };

  const exportJsonData = (type) => {
    const inprogresstoast = toast.info(
      "Downloading in progress.Please wait..."
    );

    if (type == "json") {
      setJsonLoading(true);
    } else if (type == "csv") {
      setCsvLoading(true);
    }
    let fileprefix = "";
    if (lineagedirection === "upstream") {
      fileprefix = "Upstream_Lineage_";
    } else if (lineagedirection === "downstream") {
      fileprefix = "Downstream_Lineage_";
    } else if (lineagedirection === "both") {
      fileprefix = "Full_lineage_";
    }

    axios
      .get(
        `${DATABOOK_API}/lineage/datasets/${params.id}/${lineagedirection}/${type}/download`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        let basestring = res.data;
        if (type == "json") {
          FileSaver.saveAs(
            new Blob([Buffer.from(basestring, "base64").toString()], {
              type: "data:text/json;chatset=utf-8",
            }),
            fileprefix + params.id + ".json"
          );
          setJsonLoading(false);
          toast.update(inprogresstoast, {
            render: "Json file downloaded successfully.",
            type: toast.TYPE.SUCCESS,
            autoClose: 6000,
            closeButton: true,
            isLoading: false,
          });
        } else if (type == "csv") {
          let file = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${basestring}`;
          FileSaver.saveAs(file, fileprefix + params.id + ".csv");
          setCsvLoading(false);
          toast.update(inprogresstoast, {
            render: "CSV file downloaded successfully.",
            type: toast.TYPE.SUCCESS,
            autoClose: 6000,
            closeButton: true,
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        toast.update(inprogresstoast, {
          render: "Error while downloading file. " + error,
          type: toast.TYPE.ERROR,
          autoClose: 6000,
          closeButton: true,
          isLoading: false,
        });
        setCsvLoading(false);
        setJsonLoading(false);
      });
  };

  const handleLineageChange = (value) => {
    setLineageDirection(value.target.value);
    setDownloadDisableFlag(false);
    setCsvLoading(false);
    setJsonLoading(false);
  };

  const callapiwithtoken = async (callback) => {
    (async () => await getToken())();
    if (token) {
      await callback(token);
    }
    if (error) {
      try {
        const rtoken = (await instance.acquireTokenRedirect(request))
          .accessToken;
        await callback(rtoken);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const onRestore = () => {
    setInitNodes([]);
    setInitEdges([]);

    setClickedNodeInfo([]);
    setCertifiedDatasets({});
    setModalData([]);
    setmetricsData([]);
    setPastOneMonthUserVisit("");

    callapiwithtoken(fetchLineageData);
    transformDataToElements(lineageData);
  }

  return (
    <>
      <FullScreen handle={fullScreenHandle}>
        <div className="w-100">
          {initNodes &&
            initEdges &&
            initNodes.length > 0 &&
            initEdges.length > 0 ? (
            <>
              <div className="float-end d-flex p-1">
                <div className="pt-1">
                  <Radio.Group name="radiogroup">
                    <Radio value="upstream" onChange={handleLineageChange}>
                      Upstream
                    </Radio>
                    <Radio value="downstream" onChange={handleLineageChange}>
                      Downstream
                    </Radio>
                    <Radio value="both" onChange={handleLineageChange}>
                      Both
                    </Radio>
                  </Radio.Group>
                </div>

                <div className="px-2">
                  <Button
                    type="primary"
                    icon={<DownloadOutlined />}
                    size="middle"
                    loading={jsonloading}
                    onClick={() => exportJsonData("json")}
                    disabled={downloadDisableFlag}
                  >
                    JSON
                  </Button>
                </div>

                <div className="px-2">
                  <Button
                    type="primary"
                    icon={<DownloadOutlined />}
                    size="middle"
                    loading={csvloading}
                    onClick={() => exportJsonData("csv")}
                    disabled={downloadDisableFlag}
                  >
                    CSV
                  </Button>
                </div>
                <div className="px-2">
                  <Button
                    // type="primary"
                    icon={<MdRestore />}
                    size="middle"
                    // loading={csvloading}
                    onClick={onRestore}
                  // disabled={downloadDisableFlag}
                  >
                    Restore
                  </Button>
                </div>
                <div className="px-2">
                  <Button
                    type="primary"
                    icon={
                      fullScreenHandle.active ? (
                        <AiOutlineFullscreenExit size={20} />
                      ) : (
                        <AiOutlineFullscreen size={20} />
                      )
                    }
                    size="middle"
                    onClick={
                      fullScreenHandle.active
                        ? fullScreenHandle.exit
                        : fullScreenHandle.enter
                    }
                  >
                    {/* Enter Full Screen */}
                  </Button>
                </div>
              </div>
            </>
          ) : (
            <></>
          )}

          <div>
            <ReactFlowChart
              initialsNode={initNodes}
              initialsedge={initEdges}
              infoClick={infoOnClick}
              setInfoClick={setInfoOnClick}
              nodeClick={clickedNodeInfo}
              firstdata={modaldata}
              firstcertifiedetails={certifiedetails}
              firstmetrics={metricsdata}
              firstoneMonthUserVisitCount={oneMonthUserVisitCount}
              showDetails={show}
              setShowDetails={setShow}
              fullScreenHandleActive={fullScreenHandle.active}
            />
          </div>
        </div>
      </FullScreen>
    </>
  );
};

export default DataLineage;
